import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get } from 'lodash';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsCommunicationHistoryCallLogWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsCommunicationHistoryCallLogWidgetService } from 'services/memberDetailsCommunicationHistoryCallLogWidget';
 *
 * // create service instance and send/cancel request
 * const memberDetailsCommunicationHistoryCallLogWidgetService = new MemberDetailsCommunicationHistoryCallLogWidgetService();
 * const result = await memberDetailsCommunicationHistoryCallLogWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsCommunicationHistoryCallLogWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsCommunicationHistoryCallLogWidgetService extends HttpService {

    // make request and fetch data
    async fetchData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: get( response, 'body.component', {} ),
            };
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
